<template>
  <div class="smsVerification-wrap">
    <div class="head" v-show="headShow">
      <div class="back" @click="util.comBack">
        <img src="../assets/images/fanhui.png" alt="">
      </div>
      <div class="title">{{titleVal}}</div>
    </div>
    <!--<div class="block"></div>-->
    <div class="smsformwrappe">
      <div class="phonewrappe">
        <!--<span>手机号码：</span>-->
        <input class="vphone" name="" :disabled="disablephone" placeholder="请输入您的手机号码" value="" v-model="vphoneValue">
      </div>

      <div class="passwordwrappe" v-show="passwordshow">
        <!--<span>密码：</span>-->
        <input type="password" class="vpassword" name="" :disabled="disablepassw" placeholder="六位数以上的密码" value="" v-model="vpasswordValue">
      </div>

      <div v-show="codewrappershow" class="codewrappe">
        <!-- <span>验证码：</span>-->
        <input class="vcode" name="" maxlength="6" placeholder="六位验证码" v-model="vcodeValue" value="">
        <button class="vbtn" :disabled="disableCode" @click="clikCodeBtn($event)">{{codeText}}</button>
        <!--<button class="vbtn" v-show="!vCodeShow" :disabled="false" @click="clikeCodeBtn($event)">{{auth_time}}秒后重试</button>-->
      </div>
      <button class="subbtn" :disabled="disablesub" @click="clikSubBtn()">提交</button>
      <div class="change-opera">
        <span class="code-login" v-show="codeLoginshow" @click="register(1)">{{codeLoginVal}}</span>
        <span class="code-register" @click="register(2)">{{registerVal}}</span>
      </div>

    </div>
    <div class="pro-pri" v-show="showBtn">登录即代表您已同意我们的 <span class="pro-pro-proSpan" @click="pro()">《服务协议》</span>和<span class="pro-pri-proSpan" @click="pri()">《隐私政策》</span></div>
    <!--<div class="like-list-wrapper">
      <div class="like" v-for="like in likes" key="like.id" :data-id="like.id" >
         <div class="like-wrapper-flex">
           <div class="like-vatr"><img :src="like.uservatr"></div>
           <div class="like-wrapper">
             <p>{{like.username}}</p>
             <p>{{like.commentcontent}}</p>
             <p>{{like.createtime}}</p>
           </div>
         </div>
      </div>
        </div>-->

  </div>
</template>
<script>
  import {mapGetters,mapActions} from 'vuex'
  import $ from "jquery";
  import {Toast,MessageBox} from 'mint-ui'
  import websocket from '../utils/websocket'
  export default {
    data () {
      return {
        likes:'',
        auth_time:0,
        codeText:"获取验证码",
        disableCode:true,
        disablesub:true,
        disablephone:false,
        disablepassw:false,
        vphoneValue:"",
        vcodeValue:"",
        vpasswordValue:"",
        passwordshow:true,
        codewrappershow:false,
        codeLoginshow:true,
        codeLoginVal:"短信登录",
        registerVal:"快速注册",
        titleVal:"密码登录",
        clientHeight:document.documentElement.clientHeight,
        showBtn: true,  // 控制按钮盒子显示隐藏
        headShow:true,
        userinfo:{}
      }
    },
    watch:{
      vphoneValue:function(){
        let reg = /^1[3|4|5|7|8][0-9]{9}$/;
        if("短信登录" == this.titleVal){
          if(reg.test(this.vphoneValue)){
            $(".vbtn").css("color","#44b549");
            this.disableCode = false;
          }else{
            $(".vbtn").css("color","#b8bbbf");
            this.disableCode = true;
          }
        }
        if("快速注册"==this.registerVal){
          if(reg.test(this.vphoneValue) && this.vpasswordValue.length >= 6){
            this.disablesub = false;
          }else{
            this.disablesub = true;
          }
        }else if("密码登录" == this.registerVal){
          if(reg.test(this.vphoneValue) && (this.vpasswordValue.length >= 6)){
            $(".vbtn").css("color","#44b549");
            this.disableCode = false;
          }else{
            $(".vbtn").css("color","#b8bbbf");
            this.disableCode = true;
          }
          if(reg.test(this.vphoneValue) && (this.vcodeValue.length == 6) && (this.vpasswordValue.length >= 6)){
            this.disablesub = false;
          }else{
            this.disablesub = true;
          }
        }
      },
      vpasswordValue:function(){
        let reg = /^1[3|4|5|7|8][0-9]{9}$/;
        if("快速注册"==this.registerVal){
          if(reg.test(this.vphoneValue) && this.vpasswordValue.length >= 6){
            this.disablesub = false;
          }else{
            this.disablesub = true;
          }
        }else if("密码登录" == this.registerVal){
          if(reg.test(this.vphoneValue) && (this.vpasswordValue.length >= 6)){
            $(".vbtn").css("color","#44b549");
            this.disableCode = false;
          }else{
            $(".vbtn").css("color","#b8bbbf");
            this.disableCode = true;
          }
          if(reg.test(this.vphoneValue) && (this.vcodeValue.length == 6) && (this.vpasswordValue.length >= 6)){
            this.disablesub = false;
          }else{
            this.disablesub = true;
          }
        }
      },
      vcodeValue:function(){
        if("短信登录" == this.titleVal){
          let reg = /^1[3|4|5|7|8][0-9]{9}$/;
          if(reg.test(this.vphoneValue)){
            $(".vbtn").css("color","#44b549");
            this.disableCode = false;
          }else{
            $(".vbtn").css("color","#b8bbbf");
            this.disableCode = true;
          }

          if(reg.test(this.vphoneValue) && (this.vcodeValue.length == 6)){
            this.disablesub = false;
          }else{
            this.disablesub = true;
          }
        }
        if("密码登录"==this.registerVal){
          let reg = /^1[3|4|5|7|8][0-9]{9}$/;
          if(reg.test(this.vphoneValue)){
            $(".vbtn").css("color","#44b549");
            this.disableCode = false;
          }else{
            $(".vbtn").css("color","#b8bbbf");
            this.disableCode = true;
          }
          if(reg.test(this.vphoneValue) && (this.vcodeValue.length == 6) && (this.vpasswordValue.length >= 6)){
            this.disablesub = false;
          }else{
            this.disablesub = true;
          }
        }

      }
    },
    mounted () {
      this.axios.defaults.withCredentials=true;
      this.$store.dispatch('setCurindex',4)
      this.id = this.$store.state.mutation.userinfo.id; //用户唯一标识
      //this.userinfo = this.$store.state.mutation.userinfo;
      const qs = require('qs');
      //this.token = this.$store.state.mutation.token;
      this.token = window.localStorage.getItem("token");
      /*this.axios.post('qz/getMyliked',qs.stringify({userid:this.id}))
        .then((response)=>{
          var data = response.data;
          var code = data.code;
          if(0==code){
            this.likes = response.data.data;
          }
        })*/
      window.onresize= ()=>{
        if(this.clientHeight>document.documentElement.clientHeight) {
          this.showBtn =false
        }else{
          this.showBtn = true
        }
      }
    },
    methods: {
      //点击获取验证码
      clikCodeBtn(e){
        var _self = this;
        const qs = require('qs');
        var tag = '0'; //0：登录 1：注册
        if("快速注册" == this.titleVal){
          tag = '0';
        }else if("密码登录" == this.titleVal){
          tag = '1';
        }else if("短信登录"==this.titleVal){
          tag = '2';
        }
        this.axios.post('qz/sendSms',qs.stringify({vphone:this.vphoneValue,tag:tag}))
          .then((response)=>{
            var data = response.data;
            var code = data.code;
            if(0==code){
              MessageBox.alert('',{
                title:'提示',
                message:data.data,
              });
              let $el = $(e.currentTarget);
              _self.disablephone = true;
              let btnText = $el.html();
              $el.css("color","#b8bbbf");
              _self.auth_time = 60;
              _self.codeText=this.auth_time+"秒后重试";
              var auth_timetimer = setInterval(()=>{
                _self.disableCode = true;
                _self.auth_time--;
                _self.codeText=this.auth_time+"秒后重试";
                if(_self.auth_time<=0){
                  _self.disablephone = false;
                  _self.disableCode=false;
                  _self.codeText="获取验证码";
                  $el.css("color","#44b549");
                  clearInterval(auth_timetimer);
                }
              },1000)
            }else{
              MessageBox.alert('',{
                title:'提示',
                message:data.msg,
              });
            }
          }).catch(function (error) {
          var reg = RegExp(/Network Error/);
          if(reg.test(error)){
            Toast("网络不可用！请设置网络");
          }
        })
      },
      //点击提交手机信息
      clikSubBtn(){
        var _self = this;
        const qs = require('qs');
        var tag = '0'; //0：登录 1：注册
        if("快速注册" == this.titleVal){
          tag = '0';
        }else if("密码登录" == this.titleVal){
          tag = '1';
        }else if("短信登录"==this.titleVal){
          tag = '2';
        }
        this.axios.post('qz/subVphoneVCode',qs.stringify({token:this.token,authTime:this.auth_time,
          //this.axios.post('http://localhost:8085/qz/subVphoneVCode',qs.stringify({token:this.token,authTime:this.auth_time,
          vcode:this.vcodeValue,vphone:this.vphoneValue,password:this.vpasswordValue,tag:tag}))
          .then((response)=>{
            var data = response.data;
              var code = data.code;
              if(0==code){
              window.localStorage.setItem('token',data.data.token);
              _self.id = data.data.user.id;
              _self.$store.dispatch("setToken",data.data.token);
              _self.$store.dispatch('setUserinfo',data.data.user);
              _self.$store.dispatch('hasLogin');
              _self.userinfo=data.data.user;
              //_self.$store.dispatch('setWebsocket',{"fromUser":"张三","tuUser":"李四","data":"测试数据"});
              //websocket.webSocketConn();
              /*if ('WebSocket' in window) {
                this.websocket = new WebSocket('ws://8.134.212.221:3333')
                this.initWebSocket()
              } else {
                alert('不支持连接websocket')
              }*/

              if('0'==tag){
                Toast({
                  message:"注册成功",
                  duration:500
                });
              }else if(tag = '1'){
                Toast({
                  message:"登录成功",
                  duration:500
                });
              }else if(tag = '2'){
                Toast({
                  message:"登录成功",
                  duration:500
                });
              }
              _self.openSqlite();
              //websocket.webSocketConn();
              /*var pwebsocket = new Pwebsocket({
                userId:_self.userinfo.id,
                socketUrl:'ws://8.134.212.221:3333'
              });
              p*/websocket.webSocketConn();
              /*this.$store.dispatch("setWebsocket",pwebsocket);*/
              //var msg = pwebsocket.getUNREADMSG();
              //alert("获取未读消息"+JSON.stringify(msg));
              setTimeout(()=>{
                _self.$router.go(-1);
              },600)
            }else{
              MessageBox.alert('',{
                title:'提示',
                message:data.msg,
              });
            }
          }).catch(function (error) {
          var reg = RegExp(/Network Error/);
          if(reg.test(error)){
            Toast("网络不可用！请设置网络");
          }
        })
      },
      pro(){
        this.$router.push({path:'/useProtocol'})
      },
      pri(){
        this.$router.push({path:'/privacyAgreement'})
      },
      register (num) {
        if(num ==1 && "短信登录"==this.codeLoginVal){
          if("密码登录"==this.registerVal){
            this.titleVal = "短信登录";
            this.codewrappershow=true;
            this.registerVal = "快速注册";
            this.disablesub = true;
            this.codeLoginVal="密码登录";
            this.codeLoginshow = true;
            this.passwordshow = false;
          }else{
            this.titleVal = "短信登录";
            this.passwordshow = false;
            this.codewrappershow=true;
            this.disablesub = true;
            this.codeLoginVal="密码登录";
            this.codeLoginshow = true;
          }

        }else if(num ==1 && "密码登录"==this.codeLoginVal){
          this.titleVal = "密码登录"
          this.codewrappershow=false;
          this.registerVal = "快速注册";
          this.disablesub = true;
          this.codeLoginVal="短信登录";
          this.codeLoginshow = true;
          this.passwordshow = true;
        }else if(num ==2 && "快速注册"==this.registerVal){
          this.titleVal = "快速注册";
          this.codewrappershow=true;
          this.registerVal = "密码登录";
          this.disablesub = true;
          this.codeLoginVal="短信登录";
          this.codeLoginshow = true;
          this.passwordshow = true;
        }else if(num ==2 && "密码登录"==this.registerVal){
          this.titleVal = "密码登录"
          this.codewrappershow=false;
          this.registerVal = "快速注册";
          this.disablesub = true;
          this.codeLoginVal="短信登录";
          this.codeLoginshow = true;
          this.passwordshow = true;
        }
      },
      openSqlite(){
          var _self = this;
          plus.sqlite.openDatabase({  //打开数据库
            name:'c'+_self.userinfo.id+'',
            //name:'chatMsg',
            path:'_doc/cmsg.db',
            success:function(e){
              console.log('jfkdsjk===================================executeSql success!');
/*              plus.sqlite.executeSql({ //创建用户表
                name:'c'+_self.userinfo.id+'',
                sql:'create table if not exists c'+_self.userinfo.id+'user ("id" INT(20),"userId" CHAR(200),"createTime" CHAR(20))',
                success:function(e){
                  console.log('executeSql success!');
                }
              });*/
              plus.sqlite.executeSql({ //创建消息表
                name:'c'+_self.userinfo.id+'',
                sql:'create table if not exists c'+_self.userinfo.id+'msg ("id" INT(20),"chatid" CHAR(200),"sendType" CHAR(20),"content" CHAR(200),"sendMediaType" CHAR(20),"fromUserId" INT(20),"toUserId" INT(20),"ofUserType" CHAR(20),"isReaded" CHAR(5),"createTime" CHAR(20),"audioBase64" TEXT,"audioduration" CHAR(20),"isError" CHAR(20),"ofUserId" CHAR(20))',
                success:function(e){
                  console.log('executeSql success!');
                }
              });
              console.log('openDatabase success!');
            },
            fail:function(e){
              console.log('openDatabase failed: '+JSON.stringify(e));
            }
          });
      },
      codeLogin(){
        this.codeLoginshow = false;

      },
      star () {

      }/*,
    initWebSocket () {
      // 连接错误
      this.websocket.onerror = this.setErrorMessage

      // 连接成功
      this.websocket.onopen = this.setOnopenMessage

      // 收到消息的回调
      this.websocket.onmessage = this.setOnmessageMessage

      // 连接关闭的回调
      this.websocket.onclose = this.setOncloseMessage

      // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
      window.onbeforeunload = this.onbeforeunload
    },
    setErrorMessage () {
      console.log('WebSocket连接发生错误   状态码：' + this.websocket.readyState)
    },
    setOnopenMessage () {
      /!*if(this.websocket.readyState == this.websocket.onopen){*!/
      console.log('WebSocket连接成功    状态码：' + this.websocket.readyState)
      var data = {
        "userId":this.id,
        "type":"REGISTER"
      };
      this.websocket.send(JSON.stringify(data));
      /!*}else{
        alert("Websocket连接没有开启！");
      }*!/

    },
    setOnmessageMessage (event) {
      var _self = this.websocket;
      // 根据服务器推送的消息做自己的业务处理
      console.log('服务端返回：' + event.data)
      var result = JSON.parse(event.data);
      var status = result.status;
      var bsType = result.data.type;
      if(200 == status){
        if(bsType == 'REGISTER'){
          this.$store.dispatch("setWebsocket",this.websocket);
          /!*this.get_data();*!/
          this.sendUnReadMsg();
        }
        if(bsType == 'UNREADMSG'){
          /!*alert("测试"+JSON.stringify(result.data));*!/
        }
        if(bsType == 'SINGLE_SENDING'){
          /!*alert(JSON.stringify(result.data));*!/
        }
      }

    },
    setOncloseMessage () {
      console.log('WebSocket连接关闭    状态码：' + this.websocket.readyState)
    },
    onbeforeunload () {
      this.closeWebSocket()
    },
    closeWebSocket () {
      this.websocket.close()
    },

    sendUnReadMsg(){
      var data = {
        "userId":this.id,
        "type":"UNREADMSG"
      }
      this.websocket.send(JSON.stringify(data));
    }*/
    }
  }
</script>
<style scoped>
  * {
    margin: 0;
    padding: 0;
    -webkit-touch-callout:none; /*系统默认菜单被禁用*/
    -webkit-user-select:none; /*webkit浏览器*/
    -khtml-user-select:none; /*早期浏览器*/
    -moz-user-select:none;/*火狐*/
    -ms-user-select:none; /*IE10*/
    user-select:none;
  }
  input {
    -webkit-user-select:auto; /*webkit浏览器*/
  }
  textarea {
    -webkit-user-select:auto; /*webkit浏览器*/
  }
  .smsVerification-wrap {
    width: 100%;
    height: 100%;
    background-color:transparent;
    /*opacity:0;*/
  }
  .smsVerification-wrap .head {
      position: fixed;
      top: 0;
      left: 0;
      display: -webkit-flex;
      display: flex;
      width: 100%;
      height: 2.3rem;
      align-items: center;
      background-color:transparent !important;
  }
  .smsVerification-wrap .back{
    position: absolute;
  }
  .smsVerification-wrap .back img{
      width: 1.5rem;
      height: 1.5rem;
  }
  .smsVerification-wrap .title {
      flex: 1;
      text-align: center;
      font-size: 1.1rem;
  }
  .smsVerification-wrap .block{
      height: 2.5rem;
      background-color:transparent;
  }

  .like div img{
    width: 100%;
    height: 100%;
    display: inline-block;
    border-radius: 0.3rem;
  }
  .like-list-wrapper ul li{
    display: inline-block;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    width: 100%;
    height: 3rem;
    line-height: 1.8rem;
    box-sizing: border-box;
    border-bottom: solid 1px #f7f7f7;
  }
  .like-list-wrapper ul li:after {
    content: '';
    display: inline-block;
    box-sizing: border-box;
    float: right;
    height: .8rem;
    width: .8rem;
    margin-top: 0.6rem;
    border-width: 2px 2px 0 0;
    border-color:#999;
    border-style: solid;
    transform: rotate(45deg);

  }

  .like-wrapper-flex .like-wrapper p:first-child{
     font-size: 0.8rem;
     margin-bottom: 0.2rem;
     font-weight: bold;
   }
  .like-wrapper-flex .like-wrapper p:nth-child(2){
    font-size: 0.5rem;
  }
  .like-wrapper-flex .like-wrapper p:nth-child(3){
    font-size: 0.3rem;
    margin-top: 0.4rem;
    margin-bottom: 0px;
  }
  .setting-list-wrapper ul li span{

  }

  .message img, .givestar img{
      width: 2.4rem;
      height: 2.4rem;
  }

  .buttonwrap button{
    display: inline-block;
    width: 90%;
    height: 3rem;
    line-height: 3rem;
    background-color: #d81e06;
    border: none;
    color: white;
    border-radius: 0.2rem;
    outline-style: none ;
  }
  .smsformwrappe{
    position: fixed;
    left: 0;
    top: 3rem;
    display: flex;
    flex-direction:column;
    justify-content:center;
    width: 100%;
    /*text-align: center;*/
    padding-top: 5rem;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    box-sizing: border-box;
    /*opacity:0;*/
    background-color:transparent !important;
    /*background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0);*/
  }
  .phonewrappe{
    /*padding-left: 5rem;
    padding-right: 5rem;*/
    width: 100%;
    margin-bottom: 2rem;
    border-bottom: solid 0.01rem #D7DBD8;
  }
  .passwordwrappe{
    width: 100%;
    margin-bottom: 2rem;
    border-bottom: solid 0.01rem #D7DBD8;
  }
  .passwordwrappe > input{
    height: 2rem;
    width: 100%;
    border: none;
    outline: none;
    font-size: 1.1rem;
    margin-bottom: 0.1rem;
  }
  .passwordwrappe > span{
    width: 38%;
    font-size: 1.1rem;
  }
  .phonewrappe > input{
     height: 2rem;
     width: 100%;
     border: none;
     outline: none;
    font-size: 1.1rem;
    margin-bottom: 0.1rem;
  }
  .phonewrappe > span{
     width: 30%;
     font-size: 1.1rem;
  }
  .codewrappe{
    display: flex;
    width: 100%;
    margin-bottom: 2rem;
    border-bottom: solid 0.01rem #D7DBD8;
  }
  .codewrappe > input{
    flex: 1;
    /*width: 62%;*/
    height: 2rem;
    border: none;
    outline: none;
    font-size: 1.1rem;
    margin-bottom: 0.1rem;
  }
  .codewrappe > span{
    /*width: 30%;*/
    font-size: 1.1rem;
  }
    .codewrappe > button{
      /*width: 26%;*/

      height: 2rem;
      margin-left: 0;
      margin-right: 0;
      /*color: #44b549;*/
      color: #b8bbbf;
      /*background-color: white;*/
      border: none;
      outline: none;
      background-color: rgb(0, 0, 0);
      background-color: rgba(0, 0, 0, 0);
    }
    .subbtn{
      height: 2.5rem;
      width: 100%;
      border: none;
      outline: none;
      font-size: 1.1rem;
      background-color: #44b549;
      /*color: #ffffff;*/
      border-radius: 0.2rem;
    }
    .vphone{
      width: 100%;
      /*background-color: white;*/
      background: url("../assets/images/vphoneName.png") no-repeat left center;
      background-size: 1.5rem;
      padding-left: 2rem;
    }
    .vpassword{
      /*background-color: white;*/
      background: url("../assets/images/vpassword.png") no-repeat left center;
      background-size: 1.5rem;
      padding-left: 2rem;
    }
    .vcode{
      background: url("../assets/images/vcode.png") no-repeat left center;
      background-size: 1.5rem;
      padding-left: 2rem;
    }
    .change-opera{
      display: flex;
      align-items: center;
     justify-content:space-between;
    }
    .change-opera .code-login{
      display: inline-block;
      margin-top: 0.5rem;
      color: #bababc;
      font-size: 1.1rem;
    }
    .change-opera .code-register{
      display: inline-block;
      margin-top: 0.5rem;
      color: #bababc;
      font-size: 1.1rem;
      margin-right: 0.5rem;
    }
    .pro-pri{
      position: fixed;
      display: flex;
      box-sizing: border-box;
      width: 100%;
      justify-content: center;
      bottom: 0.5rem;
      font-size: 0.8rem;
      color: #BABABC;
    }
    .pro-pro-proSpan{
      color: #047E30;
    }
    .pro-pri-proSpan{
      color: #047E30;
    }
</style>



// WEBPACK FOOTER //
// src/pages/SmsVerification.vue